
import { useState, useEffect } from 'react';
import { toast } from "@/components/ui/use-toast";
import { parseCommand } from '@/lib/utils';

export function useChatCommands(
  message: string,
  onClearChat?: () => void,
  onOpenCodeEditor?: () => void,
  onExportChat?: () => void,
  onActivateKnowledgeBase?: (kbId: string) => void,
  setMessage?: (message: string) => void
) {
  // Track if a command is being entered
  const [isCommandMode, setIsCommandMode] = useState(false);
  const [currentCommand, setCurrentCommand] = useState('');
  
  // Process command when detected
  useEffect(() => {
    if (!message) {
      setIsCommandMode(false);
      setCurrentCommand('');
      return;
    }

    // Detect command mode
    if (message.startsWith('/')) {
      setIsCommandMode(true);
      const commandParts = message.slice(1).split(' ');
      setCurrentCommand(commandParts[0].toLowerCase());
      console.log(`Command detected: ${commandParts[0].toLowerCase()}`);
    } else {
      setIsCommandMode(false);
      setCurrentCommand('');
    }
  }, [message]);

  // Execute a command
  const executeCommand = (fullMessage: string) => {
    if (!isCommandMode) return false;
    
    const { commands } = parseCommand(fullMessage);
    console.log("Executing commands:", commands);
    
    if (commands.includes('clear') && onClearChat) {
      onClearChat();
      setMessage?.('');
      toast({
        title: "Chat cleared",
        description: "All messages have been cleared"
      });
      return true;
    }
    
    if (commands.includes('code') && onOpenCodeEditor) {
      onOpenCodeEditor();
      toast({
        title: "Code editor opened",
        description: "You can now create or edit code snippets"
      });
      setMessage?.('');
      return true;
    }
    
    if (commands.includes('export') && onExportChat) {
      onExportChat();
      setMessage?.('');
      return true;
    }
    
    // Handle knowledge base command - but this is now handled by the UI component
    // with the dropdown selector, so we just return false to let that component handle it
    if (commands.includes('kb')) {
      console.log("KB command detected, letting UI component handle it");
      return false;
    }
    
    return false;
  };

  return {
    isCommandMode,
    currentCommand,
    executeCommand
  };
}
